<template>
    <tr class="el-row" :class="condensed && 'condensed'">
        <td
            v-for="(cell, i) in row"
            :key="i"
            :style="styles_col(i)"
            :class="cell_classes(cell)"
            :colspan="get_colspan(cell)"
            :rowspan="get_rowspan(cell)"
            class="el-row__cell"
        >
            <icon v-if="i===0 && icon" :file="icon" size="16" />
            <span v-if="_.isObject(cell)" class="el-row__content">
                <span v-if="show_prefix_suffix(cell, 'prefix')" class="prefix">
					<icon v-if="cell.prefix_type === 'icon'" :file="cell.prefix" :size="cell.prefix_size || 32" class="q-mr-sm" />
					<span v-else>
						{{ cell.prefix }}
					</span>
				</span>
                <span class="value">
					<template v-if="cell.type === 'image'">
						<el-image
							v-if="cell.parent_data && (cell.parent_data[cell.property].src !== '' || editing)"
							max_height="80px"
							edition_position="right"
							:parent_data="cell.parent_data[cell.property]"
							property="src"
							:editable="cell.editable"
							@changed_value="changed_value($event, i)"
						/>
					</template>
                    <el-textarea
                        v-else-if="cell.parent_data"
                        :parent_data="cell.parent_data"
                        :property="cell.property"
                        :format="cell.format"
                        :editable="cell.editable"
                        max_width="50%"
                        :selectAllOnFocus="true"
                        :component="component"
                        @changed_value="changed_value($event, i)"
						:restrict_input="cell.restrict_input"
                    />
                    <span v-else>{{ format_value(cell) }}</span>
                </span>
                <span v-if="show_prefix_suffix(cell, 'suffix')" class="suffix">
					<icon v-if="cell.suffix_type === 'icon'" :file="cell.suffix" :size="cell.suffix_size || 32" class="q-ml-sm" />
					<span v-else>
						&nbsp; {{cell.suffix }}
					</span>
				</span>
                <br v-if="editing && cell.legend" />
                <span v-if="editing" class="legend"> {{ cell.legend }}</span>
                <span v-if="cell.sub_value" class="sub-value green"><br />{{ cell.sub_value }}</span>
            </span>
            <span v-else-if="cell" class="el-row__content">{{ cell }}</span>
        </td>
    </tr>
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";
import ElTextarea from "@/components/study/editor/elements/el-textarea";
import ElImage from "@/components/study/editor/elements/el-image";
import Icon from "@/components/global/icon";

export default {
	name: "el-row",
	mixins: [ElementMixin],
	data: function () {
		return {};
	},
	props: {
		row: { default: "" },
		index: { default: "" },
		type: { default: "" },
		config: { default: [] },
		colspan: { default: 1 },
		rowspan: { default: 1 },
		icon: { default: "" },
		condensed: { default: false },

		component: { default: undefined }
	},
	computed: {
		...mapGetters([ ]),
		editing () {
			return this.editor.mode === "editing";
		},
	},
	methods: {
		get_colspan (cell) {
			if (_.isObject(cell) && cell.colspan) {
				return cell.colspan;
			}
			return 1;
		},
		get_rowspan (cell) {
			if (_.isObject(cell) && cell.rowspan) {
				return cell.rowspan;
			}
			return 1;
		},
		show_prefix_suffix (cell, field = "prefix") {
			if (!cell[field]) return false;
			if (cell.parent_data) {
				// check if there is a real value
				const v = cell.parent_data[cell.property];
				// if (v == '-') return false
				if (typeof (v) == "string" && v.length == 0) return false;
				if (typeof (v) == "number" && isNaN(v) == true) return false;
				return true;
			}
			if (cell.value) {
				//if (cell.value == '-') return false
				if (typeof (cell.value) == "string" && cell.value.length == 0) return false;
				return true;
			}
			return true;
		},
		cell_classes (cell) {
			const classes = {};
			if (!_.isObject(cell)) {
				return classes;
			}
			if (cell.bg_color) {
				classes[`bg-${cell.bg_color}`] = true;
			}
			if (cell.text_color) {
				classes[`text-${cell.text_color}`] = true;
			}
			if (cell.text_align) {
				classes[cell.text_align] = true;
			}
			if (cell.border) {
				classes[cell.border] = true;
			}
			if (cell.classes) {
				classes[cell.classes] = true;
			}
			return classes;
		},
		getCellIndexWithColspan (i) {
			let cellIndex = 0;

			for (let index = 0; index < i; index++) {
				if(this.row[index]) {
					cellIndex += this.row[index].colspan || 1;
				} else {
					cellIndex++;
				}
			}

			return cellIndex;
		},
		styles_col: function (i) {
			const styles = [];
			const cellIndex = this.getCellIndexWithColspan(i);

			if (this.config && this.config.cols_width && this.config.cols_width[cellIndex])
				styles.push({ width: this.config.cols_width[cellIndex] + "%" });

			return styles;
		},
		format_value: function (cell) {
			if (!cell || _.isUndefined(cell.value)) {
				// console.log("format_value", cell);
				return null;
			}
			if (cell.suffix && cell.suffix == "%") {
				return this.format_percent(cell);
			}
			let value = cell.value;
			if (cell.format) {
				if (cell.format == "number" || typeof cell.value == "number") {
					value = this.round_100(cell.value, 1); // number.format(cell.value)
				}
			}
			return value;
		},
		format_percent: function (cell) {
			const value = parseFloat(cell.value.replace(",", "."));
			if (isNaN(value)) return cell.value;
			const result = Math.round(value);
			return result;
		},

		changed_value: function (event, i) {
			this.$emit("changed_value", {value: event, element: i});
		}
	},
	components: { ElTextarea, ElImage, Icon },
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'

.legend
    color black
    z-index 10001
    display inline-block
    margin 0 0 0 4px

.el-row
    >>> .icon
        margin-right 8px

    &__cell
        white-space nowrap

        &.bg-green
            background #9fce63
        &.bg-yellow
            background #f5c242
        &.bg-orange
            background #f19e4b
        &.bg-header
            background #455c58 !important
        &.bg-gray
            background #eee

        &.text-white
            color #fff

        &.center
            .el-row__content
                .el-textarea
                    float none

.el-row
	>>> .el-row__content
		white-space normal
		display inline-flex
		align-items center

.table
	&.center
		tbody, thead
			tr
				td
					text-align center
					&.left
						text-align left
	thead
		tr
            td
                color main_color
                font-weight 700
                line-height 12px
                padding-top 5px
                padding-bottom 5px
                text-align left
		tr:last-child
			td
				border-bottom 1px solid main_color
	tr
		background-clip padding-box
		&:last-child
			td
				border-bottom none
		&.total
			td
				box-shadow inset 0 1px 0 0 main_color
				color main_color
				font-weight 500
		td
			font-weight bold
			padding 8px
			background-clip padding-box
			text-align left
			line-height 12px
			border-bottom 1px solid lighten(gray, 50%)

			&.border_right
				border-right 1px solid lighten(gray, 50%)

			&:first-child
				color main_color
			.sub-value
				font-size 10px
			.green
				color darken(green, 10%)
			.red
				color red
			.suffix
				display inline-block
				margin 0 0 0 4px
            .legend
                color black
                z-index 10001
			.prefix
				display inline-block
				float left
				margin 0 4px 0 0
			.value
                display inline-block
                vertical-align middle
				> span
					display inline-block
				.el-textarea
					float left
				.input
					min-height 14px
					outline none
					text-align center
					// max-width 75%
			&:not([rowspan="1"])
                background #eee
                border-bottom none
		&.condensed
			td
				padding 4px

</style>
